import { useState } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { RequestSparkAccountModal } from './RequestSparkAccountModal';

interface RequestSparkAccountActionProps {
    practiceId: string;
}

// Sibling to CreateBillComCustomerAction - sits below the sparkAcct field (as
// an accessory - see DetailsTab's fieldAccessories) while it's empty,
// alongside the field's own input rather than in place of it. Opens a modal
// that previews then sends a "request a Spark account" email rather than
// writing anything to this practice directly - see
// RequestSparkAccountModal.
export function RequestSparkAccountAction({ practiceId }: RequestSparkAccountActionProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="self-start inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-gray-300 bg-white text-[13px] font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors"
            >
                <PaperAirplaneIcon className="h-3.5 w-3.5" />
                Request Spark account
            </button>
            {isOpen && (
                <RequestSparkAccountModal
                    practiceId={practiceId}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
